exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul li[data-v-605b6f9d]{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.tooltip-inner[data-v-605b6f9d]{max-width:90%!important}", ""]);

// exports
